import { useContext, type FC } from 'react';
import { useTranslation } from 'react-i18next';

import ButtonIcon from '@tmh-website/ui/ButtonIcon';
import CMSLink from '@tmh-website/components/shared/CMSLink';
import User from '@tmh-website/components/icons/phosphor-extension/icons/User';
import { ElectricityTariffContext } from '@tmh-website/shared';
import { isNonEmptyTrimmedString } from '@tmh-website/shared/helpers';
import { isValidLinkField } from '@tmh-website/shared/cms';

import type { LinkCustomerPortalProps } from './LinkCustomerPortal.contracts';

export const LinkCustomerPortal: FC<LinkCustomerPortalProps> = ({ themeColor }) => {
  const { t } = useTranslation();
  const { theme } = useContext(ElectricityTariffContext);

  const { customerPortalLink } = theme;

  if (!isValidLinkField(customerPortalLink)) {
    return null;
  }

  const label: string = isNonEmptyTrimmedString(customerPortalLink.label)
    ? customerPortalLink.label
    : t('global:menu.myAccount');

  return (
    <CMSLink link={customerPortalLink}>
      <ButtonIcon {...{ themeColor }} aria-label={label} isTransparent>
        <User size={40} isSmall />
      </ButtonIcon>
    </CMSLink>
  );
};
